module.exports = __webpack_public_path__ + "static/media/hypercube.7666e6f4.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/hypercube.gif
 ** module id = 365
 ** module chunks = 0
 **/